import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
//@ts-ignore
import styles from './calltoaction.module.css'
import { openPopupWidget } from 'react-calendly';

const useCTAText = () => {
    const data = useStaticQuery(graphql`
    query CTAText {
        allContentfulTargetedText(filter: {name: {eq: "CTA title"}}){
            nodes {
                    content {
                      childMarkdownRemark {
                        html
                      }
                       content
                    }
            }
        }
    }
    `);

    return data?.allContentfulTargetedText?.nodes?.[0]?.content
}
export const CallToAction: React.FunctionComponent<{buttonData: any}> = ({buttonData}) => {
    const content = useCTAText();
    const openCalendly = () => {
        openPopupWidget({url: buttonData?.url})
    }
    return(
        <div className={styles.callToActionContainer}>
            {/* <p>To see how SalesBeat can help your business schedule a quick demo</p> */}
            <div className={styles.dynamicTextBox} dangerouslySetInnerHTML={{__html: content?.childMarkdownRemark?.html}}></div>
            <div className={styles.bookAdemo} onClick={openCalendly}>
                {/* <a href={buttonData?.url}>{buttonData?.buttonText}</a> */}
                <div>{buttonData?.buttonText}</div>
            </div>
        </div>
    )
}